import { sendToURL, RoutePushDispatch, RouteAddIndexRouteDispatch } from './Actions/ReduxRouterActions'
import { ShowErrorDispatch, ShowWarningDispatch, ShowSuccessDispatch,
  ShowInfoDispatch } from './Actions/ShowNotificationActions'
import { ClearValueDispatch, SetValueDispatch, UpdateArrayValueDispatch, AppendArrayValueDispatch, ClearArrayValueDispatch } from './Actions/AppStateActions'
import { SetSettingsDispatch, ClearSettingsDispatch, SetAccountDispatch, ClearAccountDispatch, UpdateAccountDispatch } from './Actions/CurrentSessionActions'
import { formCheckForSubmissionErrors, formShowSubmissionErrors, formInitValues, formResetValues, formSubmit, formDestroy, formRegisterField, formSetFieldValue,
  formUnregisterField, formRegisterFieldArray, formResetFieldStates, formStopSubmit } from './Actions/ReduxFormActions'
import _ from 'common-tools/LodashHelper'
import { OpenDrawerDispatch, CloseDrawerDispatch } from './Actions/DrawerActions'
import { AddLayoutBreadCrumbKeyDispatch, ClearLayoutBreadCrumbKeysDispatch } from './Actions/LayoutActions'
import { FormatHelper } from 'common-tools/FormatHelper'

const helperFunctions = {
  // router
  sendToURL,
  routePush: RoutePushDispatch,
  routeAddIndexRoute: RouteAddIndexRouteDispatch,

  // form
  formInitValues,
  formResetValues,
  formCheckForSubmissionErrors,
  formShowSubmissionErrors,
  formSubmit,
  formDestroy,
  formRegisterField,
  formUnregisterField,
  formSetFieldValue,
  formRegisterFieldArray,
  formResetFieldStates,
  formStopSubmit,

  // message
  // showCustom: ShowCustomDispatch,
  showError: ShowErrorDispatch,
  showSuccess: ShowSuccessDispatch,
  showWarning: ShowWarningDispatch,
  showInfo: ShowInfoDispatch,
  // showLoading: ShowLoadingDispatch,
  // clearLoading: ClearLoadingDispatch,

  // app state
  clearAppState: ClearValueDispatch,
  setAppState: SetValueDispatch,
  updateAppStateArray: UpdateArrayValueDispatch,
  appendAppStateArray: AppendArrayValueDispatch,
  clearAppStateArray: ClearArrayValueDispatch,

  // current session
  setSettings: SetSettingsDispatch,
  clearSettings: ClearSettingsDispatch,
  setAccount: SetAccountDispatch,
  clearAccount: ClearAccountDispatch,
  updateAccount: UpdateAccountDispatch,

  // drawer
  openDrawer: OpenDrawerDispatch,
  closeDrawer: CloseDrawerDispatch,

  // layout content
  addLayoutBreadCrumbKey: AddLayoutBreadCrumbKeyDispatch,
  clearLayoutBreadCrumbKeys: ClearLayoutBreadCrumbKeysDispatch,

  // tools
  formatHelper: () => { return FormatHelper }
}

export const ah = {
  // router
  sendToURL: 'sendToURL',
  routePush: 'routePush',
  routeAddIndexRoute: 'routeAddIndexRoute',

  // form
  formCheckForSubmissionErrors: 'formCheckForSubmissionErrors',
  formShowSubmissionErrors: 'formShowSubmissionErrors',
  formInitValues: 'formInitValues',
  formResetValues: 'formResetValues',
  formSubmit: 'formSubmit',
  formDestroy: 'formDestroy',
  formRegisterField: 'formRegisterField',
  formUnregisterField: 'formUnregisterField',
  formSetFieldValue: 'formSetFieldValue',
  formRegisterFieldArray: 'formRegisterFieldArray',
  formResetFieldStates: 'formResetFieldStates',
  formStopSubmit: 'formStopSubmit',

  // message
  showError: 'showError',
  showWarning: 'showWarning',
  showSuccess: 'showSuccess',
  showCustom: 'showCustom',
  showInfo: 'showInfo',
  showLoading: 'showLoading',
  clearLoading: 'clearLoading',

  // app state
  clearAppState: 'clearAppState',
  setAppState: 'setAppState',
  updateAppStateArray: 'updateAppStateArray',
  appendAppStateArray: 'appendAppStateArray',
  clearAppStateArray: 'clearAppStateArray',

  // current session
  setSettings: 'setSettings',
  clearSettings: 'clearSettings',
  setAccount: 'setAccount',
  clearAccount: 'clearAccount',
  updateAccount: 'updateAccount',

  // drawer
  openDrawer: 'openDrawer',
  closeDrawer: 'closeDrawer',

  // open content nav
  addLayoutBreadCrumbKey: 'addLayoutBreadCrumbKey',
  clearLayouContentBreadCrumbKeys: 'clearLayoutBreadCrumbKeys',

  // tools
  formatHelper: 'formatHelper'
}

export const buildActions = (helpers) => {
  return (dispatch) => {
    let ret = {}
    _.forEach(helpers || [], (h) => {
      try {
        ret[h] = helperFunctions[h](dispatch)
      } catch (err) {
        console.log(`error attempting to access helper function: ${h}`)
      }
    })
    return ret
  }
}

export default ah
